import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { MARKETING_NAME } from '../../support/brand';
import { MAIA_HOME_URL, PANEL_LOGIN_URL } from '../../support/publicUrls';
import { WHATSAPP_URL } from '../../pages/MaiaLanding/content';
import BrandLogo from './BrandLogo';

function MaiaPublicHeader() {
  const { isAuthenticated } = useAuth();

  return (
    <header className="maia-header fixed top-0 left-0 right-0 z-50">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <a href={MAIA_HOME_URL} className="flex items-center gap-2.5" aria-label={MARKETING_NAME}>
          <BrandLogo className="h-8 w-8" />
          <span className="font-display text-2xl tracking-tight text-[var(--maia-ink)]">
            {MARKETING_NAME}
          </span>
        </a>

        <nav className="flex items-center gap-1 sm:gap-3">
          <a
            href="/"
            className="hidden text-sm text-[var(--maia-muted)] transition-colors hover:text-[var(--maia-ink)] md:inline"
          >
            Plataforma
          </a>
          <a
            href="/agente-ia-whatsapp"
            className="hidden text-sm text-[var(--maia-muted)] transition-colors hover:text-[var(--maia-ink)] md:inline"
          >
            IA WhatsApp
          </a>
          <a
            href="/artigos"
            className="hidden text-sm text-[var(--maia-muted)] transition-colors hover:text-[var(--maia-ink)] sm:inline"
          >
            Artigos
          </a>
          <a
            href={`${MAIA_HOME_URL}#produto`}
            className="hidden text-sm text-[var(--maia-muted)] transition-colors hover:text-[var(--maia-ink)] sm:inline"
          >
            O que é
          </a>
          <a
            href={`${MAIA_HOME_URL}#como-funciona`}
            className="hidden text-sm text-[var(--maia-muted)] transition-colors hover:text-[var(--maia-ink)] md:inline"
          >
            Como funciona
          </a>
          <a
            href={`${MAIA_HOME_URL}#oferta`}
            className="mr-1 hidden text-sm text-[var(--maia-muted)] transition-colors hover:text-[var(--maia-ink)] sm:inline"
          >
            Quem faz
          </a>
          {isAuthenticated ? (
            <Link to="/agents" className="maia-btn-primary !px-4 !py-2 text-sm">
              Painel
            </Link>
          ) : (
            <>
              <a
                href={PANEL_LOGIN_URL}
                className="hidden text-sm text-[var(--maia-muted)] transition-colors hover:text-[var(--maia-ink)] sm:inline"
              >
                Entrar
              </a>
              <a
                href={WHATSAPP_URL}
                className="maia-btn-primary !px-4 !py-2 text-sm"
                target="_blank"
                rel="noreferrer"
              >
                Fale com a MAIA
              </a>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}

export default MaiaPublicHeader;
